"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAgentListingsPropertyListingsAgentListingsGetRequest$ = exports.GetAgentListingsPropertyListingsAgentListingsGetRequest$outboundSchema = exports.GetAgentListingsPropertyListingsAgentListingsGetRequest$inboundSchema = exports.GetAgentListingsPropertyListingsAgentListingsGetSecurity$ = exports.GetAgentListingsPropertyListingsAgentListingsGetSecurity$outboundSchema = exports.GetAgentListingsPropertyListingsAgentListingsGetSecurity$inboundSchema = void 0;
exports.getAgentListingsPropertyListingsAgentListingsGetSecurityToJSON = getAgentListingsPropertyListingsAgentListingsGetSecurityToJSON;
exports.getAgentListingsPropertyListingsAgentListingsGetSecurityFromJSON = getAgentListingsPropertyListingsAgentListingsGetSecurityFromJSON;
exports.getAgentListingsPropertyListingsAgentListingsGetRequestToJSON = getAgentListingsPropertyListingsAgentListingsGetRequestToJSON;
exports.getAgentListingsPropertyListingsAgentListingsGetRequestFromJSON = getAgentListingsPropertyListingsAgentListingsGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetAgentListingsPropertyListingsAgentListingsGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetAgentListingsPropertyListingsAgentListingsGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetAgentListingsPropertyListingsAgentListingsGetSecurity$;
(function (GetAgentListingsPropertyListingsAgentListingsGetSecurity$) {
    /** @deprecated use `GetAgentListingsPropertyListingsAgentListingsGetSecurity$inboundSchema` instead. */
    GetAgentListingsPropertyListingsAgentListingsGetSecurity$.inboundSchema = exports.GetAgentListingsPropertyListingsAgentListingsGetSecurity$inboundSchema;
    /** @deprecated use `GetAgentListingsPropertyListingsAgentListingsGetSecurity$outboundSchema` instead. */
    GetAgentListingsPropertyListingsAgentListingsGetSecurity$.outboundSchema = exports.GetAgentListingsPropertyListingsAgentListingsGetSecurity$outboundSchema;
})(GetAgentListingsPropertyListingsAgentListingsGetSecurity$ || (exports.GetAgentListingsPropertyListingsAgentListingsGetSecurity$ = GetAgentListingsPropertyListingsAgentListingsGetSecurity$ = {}));
function getAgentListingsPropertyListingsAgentListingsGetSecurityToJSON(getAgentListingsPropertyListingsAgentListingsGetSecurity) {
    return JSON.stringify(exports.GetAgentListingsPropertyListingsAgentListingsGetSecurity$outboundSchema
        .parse(getAgentListingsPropertyListingsAgentListingsGetSecurity));
}
function getAgentListingsPropertyListingsAgentListingsGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetAgentListingsPropertyListingsAgentListingsGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetAgentListingsPropertyListingsAgentListingsGetSecurity' from JSON`);
}
/** @internal */
exports.GetAgentListingsPropertyListingsAgentListingsGetRequest$inboundSchema = z.object({
    agent_id: z.array(z.string()),
    "fields[listing]": z.array(shared.MultiplePropertyListingsUserFields$inboundSchema),
    "filter[max_number_of_bathrooms]": z.number().int().optional(),
    "filter[max_number_of_bedrooms]": z.number().int().optional(),
    "filter[max_price]": z.number().int().optional(),
    "filter[min_number_of_bathrooms]": z.number().int().optional(),
    "filter[min_number_of_bedrooms]": z.number().int().optional(),
    "filter[min_price]": z.number().int().optional(),
    "filter[number_of_bathrooms]": z.array(z.number().int()).optional(),
    "filter[number_of_bedrooms]": z.array(z.number().int()).optional(),
    "filter[property_type]": z.array(shared.PropertyType$inboundSchema)
        .optional(),
    "filter[status]": z.array(shared.AreaListingStatus$inboundSchema)
        .optional(),
    page: z.number().int().default(1),
    results: z.number().int().default(25),
    sort: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "agent_id": "agentId",
        "fields[listing]": "fieldsListing",
        "filter[max_number_of_bathrooms]": "filterMaxNumberOfBathrooms",
        "filter[max_number_of_bedrooms]": "filterMaxNumberOfBedrooms",
        "filter[max_price]": "filterMaxPrice",
        "filter[min_number_of_bathrooms]": "filterMinNumberOfBathrooms",
        "filter[min_number_of_bedrooms]": "filterMinNumberOfBedrooms",
        "filter[min_price]": "filterMinPrice",
        "filter[number_of_bathrooms]": "filterNumberOfBathrooms",
        "filter[number_of_bedrooms]": "filterNumberOfBedrooms",
        "filter[property_type]": "filterPropertyType",
        "filter[status]": "filterStatus",
    });
});
/** @internal */
exports.GetAgentListingsPropertyListingsAgentListingsGetRequest$outboundSchema = z.object({
    agentId: z.array(z.string()),
    fieldsListing: z.array(shared.MultiplePropertyListingsUserFields$outboundSchema),
    filterMaxNumberOfBathrooms: z.number().int().optional(),
    filterMaxNumberOfBedrooms: z.number().int().optional(),
    filterMaxPrice: z.number().int().optional(),
    filterMinNumberOfBathrooms: z.number().int().optional(),
    filterMinNumberOfBedrooms: z.number().int().optional(),
    filterMinPrice: z.number().int().optional(),
    filterNumberOfBathrooms: z.array(z.number().int()).optional(),
    filterNumberOfBedrooms: z.array(z.number().int()).optional(),
    filterPropertyType: z.array(shared.PropertyType$outboundSchema).optional(),
    filterStatus: z.array(shared.AreaListingStatus$outboundSchema).optional(),
    page: z.number().int().default(1),
    results: z.number().int().default(25),
    sort: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        agentId: "agent_id",
        fieldsListing: "fields[listing]",
        filterMaxNumberOfBathrooms: "filter[max_number_of_bathrooms]",
        filterMaxNumberOfBedrooms: "filter[max_number_of_bedrooms]",
        filterMaxPrice: "filter[max_price]",
        filterMinNumberOfBathrooms: "filter[min_number_of_bathrooms]",
        filterMinNumberOfBedrooms: "filter[min_number_of_bedrooms]",
        filterMinPrice: "filter[min_price]",
        filterNumberOfBathrooms: "filter[number_of_bathrooms]",
        filterNumberOfBedrooms: "filter[number_of_bedrooms]",
        filterPropertyType: "filter[property_type]",
        filterStatus: "filter[status]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetAgentListingsPropertyListingsAgentListingsGetRequest$;
(function (GetAgentListingsPropertyListingsAgentListingsGetRequest$) {
    /** @deprecated use `GetAgentListingsPropertyListingsAgentListingsGetRequest$inboundSchema` instead. */
    GetAgentListingsPropertyListingsAgentListingsGetRequest$.inboundSchema = exports.GetAgentListingsPropertyListingsAgentListingsGetRequest$inboundSchema;
    /** @deprecated use `GetAgentListingsPropertyListingsAgentListingsGetRequest$outboundSchema` instead. */
    GetAgentListingsPropertyListingsAgentListingsGetRequest$.outboundSchema = exports.GetAgentListingsPropertyListingsAgentListingsGetRequest$outboundSchema;
})(GetAgentListingsPropertyListingsAgentListingsGetRequest$ || (exports.GetAgentListingsPropertyListingsAgentListingsGetRequest$ = GetAgentListingsPropertyListingsAgentListingsGetRequest$ = {}));
function getAgentListingsPropertyListingsAgentListingsGetRequestToJSON(getAgentListingsPropertyListingsAgentListingsGetRequest) {
    return JSON.stringify(exports.GetAgentListingsPropertyListingsAgentListingsGetRequest$outboundSchema
        .parse(getAgentListingsPropertyListingsAgentListingsGetRequest));
}
function getAgentListingsPropertyListingsAgentListingsGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetAgentListingsPropertyListingsAgentListingsGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetAgentListingsPropertyListingsAgentListingsGetRequest' from JSON`);
}
//# sourceMappingURL=getagentlistingspropertylistingsagentlistingsget.js.map